import { formatNumber } from "../../../utils/funcHelper";

const eChart = {
  series: [
    
  ],

  options: {
    chart: {
      type: "bar",
      width: "100%",
      height: "auto",

      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 5,
      },
    },
    markers: {
      size: 6,
      strokeWidth: 3,
      fillOpacity: 0,
      strokeOpacity: 0,
      hover: {
        size: 8
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#ff0000"], // Màu chữ của số liệu
        fontSize: "12px", // Kích thước chữ
        fontWeight: "bold", // Độ đậm của chữ
      },
      formatter: function (val) {
        return formatNumber(val, 0); // Định dạng số liệu (ví dụ: 1,000)
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    grid: {
      show: true,
      borderColor: "#ccc",
      strokeDashArray: 2,
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
        align: "right",
        minWidth: 0,
        maxWidth: 160,
        style: {
          colors: "#fff",
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        align: "right",
        minWidth: 0,
        style: {
          colors: "#fff",
        },
        formatter : (val, opts) => formatNumber(val/1000, 0)
      },
    },
    title: {
      text: 'Biểu đồ thống kê doanh thu theo ngày',
      align: 'center',
      style: {
        color: '#fff'
      },
    },

    tooltip: {
      y: {
        formatter: function (val) {
          return formatNumber(val, 0) + " đ";
        },
      },
    },
  },
};

export default eChart;
